//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.PartOperationCreateBuilder.js";
let d=[[],[[["nObjects","logicalObjects"],"CreateLogicalObjectsForDialog",{},0,0],[["sessionType"],"SetSelectedSessionType",{},1,0],[[],"GetSelectedSessionType",{R_:{sessionType:''}},0,0],[["allowSessionNameAutoAssignOnPartSelection"],"SetAllowSessionNameAutoAssignOnPartSelection",{},1,0],[[],"IsAllowSessionNameAutoAssignOnPartSelection",{R_:{allowSessionNameAutoAssignOnPartSelection:''}},0,0],[[],"AutoAssignSessionNameOnPartSelection",{},0,0],[["nSessionTypes"],"GetSessionTypes",{R_:{sessionTypes:""}},0,0],[["selectedPartName"],"SetSelectedPart",{},1,0],[[],"GetSelectedPart",{R_:{selectedPartName:''}},0,0]],[]];
SPLM.PDM.CreateSessionBuilder = class extends SPLM.PDM.PartOperationCreateBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.CreateSessionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;